common.View.create('shop::Habitats.Website.Modules.ShopProducts.Index', {

    currentLoadHtmlAjax: null,

    onDOMLoad()
    {
        this.initPopState();
    },

    initPopState()
    {
        // Listen for pop state.
        window.addEventListener('popstate', event =>
        {
            //
            this.getInstances().filters.setByUrl();

            //
            this.loadHtml(true);
        });
    },

    onUserInput()
    {
        //
        this.loadHtml(false);
    },

    async loadHtml(isBack)
    {
        // Cancel current request?
        if (this.currentLoadHtmlAjax)
        {
            this.currentLoadHtmlAjax.abort();

            this.currentLoadHtmlAjax = null;
        }

        // Show products as loading.
        this.getInstances().products.setLoading();

        // Update url?
        let url = this.getUrlByState();

        if (!isBack && history.pushState)
            history.pushState(null, $('head title').text(), url);

        // Request
        this.currentLoadHtmlAjax = $.get(url);

        try {
            var response = $(await this.currentLoadHtmlAjax);
        }
        catch(ex) {
            // Abort due to aborted on purpose?
            if(ex?.statusText == 'abort')
                return;

            // Rethrow?
            else
                throw ex;
        }

        // Update HTML's.
        this.getInstances().products.updateHtml(response);
        this.getInstances().filters.updateHtml(response);
    },

    getUrlByState()
    {
        // Build query.
        let query = {
            ...this.getInstances().filters.getFilterQuery(),
            ...this.getInstances().products.getSortQuery(),
        };

        // Build url due to having query?
        if(!_.isEmpty(query))
            return '?' + new URLSearchParams(query).toString();

        // Use default url without query?
        else
            return document.location.pathname;
    },

    getInstances()
    {
        return {
            filters: this.element.find('.shop\\:\\:Habitats-Website-Modules-ShopProducts-Index-Filters').data('instance'),
            products: this.element.find('.shop\\:\\:Habitats-Website-Modules-ShopProducts-Index-Products').data('instance')
        };
    },

});